import React from 'react';
import PropTypes from 'prop-types';

import './CallToAction.css';

export const ctaSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const ctaTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

const CallToAction = (props) => {
  const { onClick, label, size, isDisabled, styleType } = props;
  return (
    <button
      type="button"
      styleName={`call-to-action ${styleType} ${size}`}
      disabled={isDisabled}
      onClick={onClick}
    >
      <span styleName="inner">{label}</span>
    </button>
  );
};

CallToAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  styleType: PropTypes.oneOf(Object.values(ctaTypes)),
  size: PropTypes.oneOf(Object.values(ctaSizes))
};

CallToAction.defaultProps = {
  isDisabled: false,
  styleType: ctaTypes.PRIMARY,
  size: ctaSizes.MEDIUM
};

/*
 * Convenience version of CallToAction that defaults options to those of a secondary CTA
 */
export const CallToActionSecondary = (props) => {
  const newProps = { ...props, styleType: ctaTypes.SECONDARY };
  return <CallToAction {...newProps} />;
};

/*
 * Convenience version of CallToAction that defaults options to those of a primary CTA
 */
export const CallToActionPrimary = (props) => {
  const newProps = { ...props, styleType: ctaTypes.PRIMARY };
  return <CallToAction {...newProps} />;
};

export default CallToAction;
